module.exports = __webpack_public_path__ + "img/industry-img2.bf28c531.png";